import { sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";
import { journalEntries } from "./journal-entries";
import { accounts } from "./accounts";

// ============================================================================
// journal_entry_items — รายการ Dr/Cr ในสมุดรายวัน
// ============================================================================
export const journalEntryItems = sqliteTable("accounting_journal_entry_items", {
  id: text("id").primaryKey(), // ULID
  journalEntryId: text("journal_entry_id").notNull().references(() => journalEntries.id), // FK → journal_entries
  accountId: text("account_id").notNull().references(() => accounts.id), // FK → accounts
  debit: real("debit").notNull().default(0),
  credit: real("credit").notNull().default(0),
  partyType: text("party_type"),
  partyId: text("party_id"),
  description: text("description"),
  costCenterId: text("cost_center_id"), // FK → cost_centers (nullable)
  // Polymorphic line-level reference (EPIC #412 Phase 1) — links a single Dr/Cr
  // line back to its source entity (vehicle/rental/customer/asset/etc.) so
  // analytic reports can group by reference even when one JE spans multiple
  // entities or is created manually. Successor allocations table (Phase 2)
  // will deprecate these in favour of multi-tag/split-percentage rows.
  lineReferenceModule: text("line_reference_module"),
  lineReferenceDoctype: text("line_reference_doctype"),
  lineReferenceId: text("line_reference_id"),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
}, (table) => ({
  jeiLineRefIdx: index("jei_line_ref_idx").on(table.lineReferenceModule, table.lineReferenceId),
}));

// Type exports
export type JournalEntryItem = typeof journalEntryItems.$inferSelect;
export type NewJournalEntryItem = typeof journalEntryItems.$inferInsert;
